import { initDataLayerInteractions } from '@config/dataLayer.js';
import MediaControl from '@config/media-control.js';
import initHeader from '@config/header.js';
import initStickyFocusReveal from '@config/sticky-focus-reveal.js';
import initFooterReveal from '@config/footer-reveal.js';

function initApp() {
  initDataLayerInteractions();
  MediaControl.init();
  initHeader();
  initStickyFocusReveal();
  initFooterReveal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}
